<script>
    import Layout from '@layouts/main'
    import PageHeader from '@components/page-header'
    import SelectWarehouse from '@components/retina/own_inventory/SelectWarehouse'
    import CountInventory from '@components/retina/own_inventory/CountInventory'
    import OnlineInventory from '@components/retina/own_inventory/OnlineInventory'
    import CountReview from '@components/retina/own_inventory/CountReview'
    import Pointer from '@components/retina/own_inventory/Pointer'
    import { mapGetters } from 'vuex'
    import { inventoryMethods, warehouseMethods } from '@state/helpers'
    
    export default {
      name: 'Inventario_Propio',
      page: {
        title: 'Inventario Propio',
        meta: [{ name: 'Inventario_Propio', content: 'Inventario_Propio' }],
      },
      components: {
        Layout,
        PageHeader,
        SelectWarehouse,
        CountInventory,
        OnlineInventory,
        CountReview,
        Pointer,
      },
      data() {
        return {
          title: '<i class="fas fa-truck"></i> Inventario Propio',
          items: [
            { 
              text: 'Inventario Propio',
              active: true,
            },
          ],
        }
      },
      computed: {
        ...mapGetters({
          own_warehouse_selected: 'retina/warehouse/own_warehouse_selected',
          own_warehouse_i: 'retina/inventory/own_warehouse_i',
          own_consult_warehouse: 'retina/warehouse/own_consult_warehouse',
          own_inventory_count_mode: 'retina/inventory/own_inventory_count_mode',
          own_inventory_count_review: 'retina/inventory/own_inventory_count_review',
          own_inventory_online_mode: 'retina/inventory/own_inventory_online_mode',
        }),
      },
      methods: {
        ...inventoryMethods,
        ...warehouseMethods,
    
        consultWarehouse() {
          return (!this.own_warehouse_selected) && (!this.own_warehouse_i) ? true 
            : this.own_inventory_count_mode
            ? false
            : this.own_inventory_count_review
            ? false
            : this.own_inventory_online_mode
            ? false
            : true
        },
      },
    }
    </script>
    
    <template>
      <Layout>
        <PageHeader :title="title" :items="items" />
    
        <Pointer />
    
        <SelectWarehouse v-if="consultWarehouse()" />
    
        <CountInventory v-if="own_inventory_count_mode" />
    
        <CountReview v-if="own_inventory_count_review" />
    
        <OnlineInventory v-if="own_inventory_online_mode" />
      </Layout>
    </template>
    